module.exports = __webpack_public_path__ + "img/s11.90c76c8.png";